import React from "react";
import TermsContent from "./TermsContent";
import PrivacyContent from "./PrivacyContent";
import DataSecurityContent from "./DataSecurityContent";

export default function LegalModal({ open, type, onClose }) {
  if (!open) return null;

  const titleMap = {
    terms:   "Terms of Service",
    privacy: "Privacy Policy",
    data:    "Data Security Policy",
  };

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/70 px-4">
      <div className="w-full max-w-4xl bg-white border border-border rounded-2xl shadow-xl flex flex-col max-h-[85vh]">

        {/* Header */}
        <div className="px-6 py-4 border-b border-border flex justify-between items-center">
          <h2 className="text-xl md:text-2xl font-semibold text-text-primary">
            {titleMap[type]}
          </h2>
          <button
            onClick={onClose}
            className="text-text-muted hover:text-text-primary text-2xl leading-none transition"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-5 overflow-y-auto text-sm text-text-secondary leading-relaxed space-y-4 scrollbar-thin scrollbar-thumb-border-strong scrollbar-track-bg-soft">
          {type === "terms"   && <TermsContent />}
          {type === "privacy" && <PrivacyContent />}
          {type === "data"    && <DataSecurityContent />}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-border flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg bg-bg-soft border border-border text-text-primary hover:bg-white hover:border-border-strong transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}